var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseRestApiServiceFactory } from '@wemogy/reactbase';
import { AuthorizationApiUri } from '../../../base/Constants';
import MemberApiService from './services/MemberApiService';
import PermissionCacheApiService from './services/PermissionCacheApiService';
var RestApiServiceFactory = /** @class */ (function (_super) {
    __extends(RestApiServiceFactory, _super);
    function RestApiServiceFactory() {
        return _super.call(this, AuthorizationApiUri) || this;
    }
    Object.defineProperty(RestApiServiceFactory.prototype, "memberApiService", {
        get: function () {
            return new MemberApiService(this.apiWrapper);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RestApiServiceFactory.prototype, "permissionCacheApiService", {
        get: function () {
            return new PermissionCacheApiService(this.apiWrapper);
        },
        enumerable: false,
        configurable: true
    });
    return RestApiServiceFactory;
}(BaseRestApiServiceFactory));
export default new RestApiServiceFactory();
//# sourceMappingURL=RestApiServiceFactory.js.map